import {memo} from 'react';
import {Text, TextProps} from '@mantine/core';
import {formatJSDate} from '../utils/luxon.ts';

type DateProps = {
  date: number | Date | string;
  format?: Intl.DateTimeFormatOptions | string;
};

export const DateTimeFormats = {
  Date: 'MM/DD/YY',
  Time: 'hh:mm A',
  DateTime: 'MM/DD/YY hh:mm A',
};

export const DateFormat = memo<DateProps & TextProps>(
  ({date, format = DateTimeFormats.Date, ...textProps}) => (
    <Text size="14px" {...textProps}>
      {formatJSDate(new Date(date), format)}
    </Text>
  )
);
